import types from "../actionTypes";

export default (
  state = {
    IsOtpSend: false,
    otpData:undefined,
  },
  action
) => {
  switch (action.type) {
    case types.IS_OTP_SEND:
      return Object.assign({}, state, { IsOtpSend: action.IsOtpSend });
      case types.SET_OTP_DATA:
      return Object.assign({}, state, { otpData: action.otpData });
    default:
      return state;
  }
};
